<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent scrollable max-width="600">
      <v-card>
        <v-card-title>
          <div class="font-weight-bold text-h4">
            Detailed Payment Request
          </div>
        </v-card-title>
        <v-card-text class="pb-0">
          <div>
            <div v-for="(header, headerIndex) in expanHeaders" :key="header">
              <div
                v-if="!(headerIndex == 2 && value.paymentType == 'Standard')"
              >
                <div class="header">
                  <h6>{{ header }}</h6>
                </div>
              </div>
              <div
                class="pt-1"
                v-if="!(headerIndex == 2 && value.paymentType == 'Standard')"
              >
                <div
                  v-for="item in expanItems[headerIndex]"
                  :key="item.name"
                  class="text-body-1 flex-row flex-wrap pb-1 dropdown-parent"
                >
                  <v-divider v-if="item.divider"></v-divider>
                  <v-divider v-if="item.divider"></v-divider>
                  <label :for="item.name" class="font-weight-bold">
                    {{ item.name }}
                  </label>
                  <p
                    :name="item.name"
                    :class="chooseColor(value[item.value])"
                    style="font-style: normal !important;
                    font-size: 14px;"
                  >
                    {{ value[item.value] }}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </v-card-text>
        <v-card-actions>
          <v-btn
            v-if="recurringStatus && hasCancelRecurringPaymentPermission"
            color="red"
            text
            @click="openConfirmation"
            >Cancel Recurring Payment</v-btn
          >
          <v-spacer />
          <v-btn color="grey darken-1" text @click="closeModal">
            Close
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <ConfirmationModal
      ref="confirmation"
      :isShowDialog="isShowConfirmationModal"
      :inputInfo="confirmationModalInfo"
      :inputColor="confirmationModalInfoColor"
      @eConfirm="cancelRecurringPayment"
      @eCancel="cancelConfirmation"
    />
  </v-row>
</template>

<script>
import CancelRecurringPaymentMixin from "@/components/widgets/CancelRecurringPaymentMixin.js";

export default {
  mixins: [CancelRecurringPaymentMixin],
  data() {
    return {
      expanHeaders: [
        "Customer  Information",
        "Payment Request Information",
        "Recurring Information"
      ],
      expanItems: [
        [
          { name: "Customer Name ", value: "customerName" },
          { name: "Email", value: "email" },
          { divider: true }
        ],
        [
          { name: "Order Number", value: "orderNumber" },
          { name: "Amount", value: "amount_currency" },
          { name: "Payment Request Id", value: "paymentRequestId" },
          { name: "Created By", value: "createdBy" },
          { name: "Reason", value: "reason" },
          { divider: true },
          { name: "Payment Set-Up ?", value: "paymentSetup" },
          { name: "Payment Type", value: "paymentType" },
          { name: "Created Date", value: "createdDate" },
          { name: "Send Date", value: "sendDate" },
          { name: "Expiry Date", value: "expiryDate" },
          { divider: true },
          { name: "Date Payment Setup", value: "setupDate" },
          { name: "Email Sent ?", value: "emailSent" },
          { name: "Email Status", value: "emailStatus" },
          { name: "Date Email Sent", value: "emailSentDate" },
          { divider: true }
        ],
        [
          { name: "Recurring Payment Status", value: "recurringStatus" },
          { name: "Initial Payment", value: "initialPaymentAmount" },
          { name: "Frequency", value: "frequency" },
          { name: "Current Period", value: "currentPeriod" },
          { name: "Total Period", value: "period" },
          { name: "Date of First Payment", value: "executionDate" }
        ]
      ]
    };
  },
  props: {
    dialog: {
      type: Boolean,
      required: true,
      default: false
    },
    value: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  methods: {
    closeModal() {
      this.$emit("closeDetailedRequestModal");
    },
    chooseColor(value) {
      if (value == "Yes" || value == "Sent" || value == "SUCCESS")
        return "font-italic green--text pl-1";

      if (value == "No" || value == "Not Sent")
        return "font-italic red--text pl-1";

      return "font-italic pl-1";
    }
  }
};
</script>

<style>
* {
  font-family: "Open Sans", sans-serif;
}
h6 {
  font-size: 18px;
  padding-top: 12px;
  padding-bottom: 12px;
  font-weight: 700;
  color: black;
}

label {
  /* Other styling... */
  clear: both;
  float: left;
  font-weight: 700;
  font-size: 14px;
  color: black;
}

.dropdown-parent {
  display: grid !important;
  grid-template-columns: 2fr 4fr !important;
}
</style>
